module.exports = __webpack_public_path__ + "static/media/cellere-icon.1ae054a2.png";